import {
  UppFloorPlanTable,
  UppFloorPlanVertex,
  type UppFloorPlanElement,
} from '../plan/floor-plan-element';
import type { UppKonvaSceneElementRef, UppKonvaSceneElementRefVertex } from './upp-konva-scene-ref';

export function toUppKonvaSceneElementRef(el: UppFloorPlanElement): UppKonvaSceneElementRef {
  const attention = el instanceof UppFloorPlanTable ? el.attention : false;
  const base = {
    uuid: el.uuid,
    zIndex: el.zIndex,
    selected: el.selected,
    label: el.label,
    sublabel: el.sublabel,
    attention,
    ...(el instanceof UppFloorPlanTable && attention
      ? { attentionTone: el.attentionTone, attentionAnimated: el.attentionAnimated }
      : {}),
    custom: el.custom,
    xCm: el.xCm,
    yCm: el.yCm,
    widthCm: el.widthCm,
    heightCm: el.heightCm,
    rotationDeg: el.rotationDeg,
  };
  if (el instanceof UppFloorPlanVertex) {
    return {
      ...base,
      kind: 'vertex',
      sort: el.sort,
      polygon: el.polygon,
      closed: el.closed,
    };
  }
  return {
    ...base,
    kind: el.kind as 'table' | 'bar' | 'furniture' | 'architecture',
  };
}

export function toUppKonvaVertexSceneRef(el: UppFloorPlanVertex): UppKonvaSceneElementRefVertex {
  return toUppKonvaSceneElementRef(el) as UppKonvaSceneElementRefVertex;
}
